export default [{
    path: '/birthday',
    component: () => import('./profile'),
    children: [{
            path: 'profile',
            name: 'birthday.profile',
            meta: {
                requiresAuth: true
            },
            component: () => import('./profile/basic')
        },
        {
            path: 'create',
            name: 'birthday.create',
            meta: {
                requiresAuth: true
            },
            component: () => import('./profile/detail')
        },
        {
            path: ':id/update',
            name: 'birthday.update',
            meta: {
                requiresAuth: true
            },
            component: () => import('./profile/detail')
        },
        {
            path: 'logs',
            name: 'birthday.logs',
            meta: {
                requiresAuth: true
            },
            component: () => import('./profile/logs')
        },
    ]
}]
